/* eslint-disable i18next/no-literal-string */
import { useCallback } from 'react';

import { Overlay } from '../Overlay/Overlay';
import { Button } from '../Button/Button';
import { LinkButton } from '../LinkButton/LinkButton';
import { logout } from '../../services/schibstedAccount';
import { rawTrackEngagementEvent } from '../../services/tracking/pulse';
import { useIdentity } from '../IdentityProvider/IdentityProvider';
import { config } from '../../config';

import type { FC } from 'react';

import * as styles from './AccountSharingPopup.module.scss';

interface AccountSharingPopupProps {
  isOpen: boolean;
}

const getRedirectUri = () => {
  const url = new URL(window.location.origin + window.location.pathname);

  // attach `utm_source` so that we can easily track new subscription purchases
  url.searchParams.set('utm_source', 'streamingcontrol');

  return url.toString();
};

const trackButtonClick = (id: string, intent?: string) => {
  rawTrackEngagementEvent({
    action: 'Click',
    intent,
    object: {
      type: 'UIElement',
      id: `account-sharing-popup:${id}`,
    },
  });
};

export const VGAccountSharingPopup: FC<AccountSharingPopupProps> = ({
  isOpen,
}) => {
  const { accountUrl, fullName } = useIdentity();

  const handleChangePasswordClick = useCallback(
    () => trackButtonClick('change-password'),
    []
  );

  const handleLogoutClick = useCallback(() => {
    trackButtonClick('logout', 'Logout');
    logout(getRedirectUri());
  }, []);

  const handleShareAccountClick = useCallback(() => {
    trackButtonClick('share-account', 'Share');
  }, []);

  return (
    <Overlay
      type="overlay/popup"
      isOpen={isOpen}
      className={styles.overlay}
      contentClassName={styles.overlayContent}
    >
      <div className={styles.container}>
        <h1 className={styles.header}>
          Det ser ut som din konto er
          <br /> i bruk på flere enheter
        </h1>
        <div className={styles.description}>
          Kontoen tilknyttet <strong>{fullName}</strong> brukes for øyeblikket
          på en annen enhet. Legg til en ekstra bruker i ditt abonnement, så får
          begge tilgang.
        </div>
        <div className={styles.buttons}>
          <LinkButton
            url={config.mySubscriptionUrl}
            onClick={handleShareAccountClick}
            size="large"
            variant="contained"
          >
            Gi tilgang (gratis)
          </LinkButton>
          <LinkButton
            url={accountUrl}
            onClick={handleChangePasswordClick}
            size="large"
            variant="contained"
            isActiveBrandColor
          >
            Endre passord
          </LinkButton>
          <Button size="large" variant="contained" onClick={handleLogoutClick}>
            Logg ut
          </Button>
        </div>
      </div>
    </Overlay>
  );
};
